import React, {useMemo} from 'react'
import {Router, Routes, Route} from '@startlibs/components'//  use this
import {Notifications as StartlibsNotifications} from '@startlibs/components'
import {callIfFunction, customTheme} from '@startlibs/utils';
import {createGlobalStyle, ThemeProvider} from 'styled-components';
import {AppRoutes} from './AppRoutes'
import {CheckScrollOnBottom} from './components/CheckScrollOnBottom'
import { HelpButton } from './components/PageLayout';
import {Notifications} from './components/Notifications'
import {PageLoadingSuspense} from './components/PageLoading'
import {ProviderErrorBoundary} from './pages/errors/ProviderError'
import {ProviderTitle} from './components/ProviderTitle'
import StartlibsConfig from './UIConfig/StartlibsConfig'
import {PreviewForReport} from './request/reviewedRequest/PreviewForReport'
import {lazyProviderInfo} from './components/WithProvider'
import {useFavicon} from './hooks/useFavicon'
import { useIntl} from 'react-intl'
import {WithLazyResource} from './hooks/useSuspense'
import { Slot, StartlibsProvider, willUseSharedState } from '@startlibs/core';
import { CustomSafariStyle, ImageSlateStyle, TableSlateStyle } from './components/slateEditor/SlateStyles';
import { createCustomColorTheme } from './UIConfig/createCustomColorTheme';
import {I18NProvider} from "./components/I18NProvider";
import {getInitLocale, I18NInitEnable, shouldAddLocaleUrlParam} from "./utils/getInitLocale";

export const [usePreviewCase, , setPreviewCase] = willUseSharedState([])

const Identity = React.forwardRef(({children}, ref) => <React.Fragment>{children}
  <div ref={ref}/>
</React.Fragment>)
Identity.displayName = 'Identity'

const DefaultStyle = createGlobalStyle`
  ${customTheme('DefaultStyle')};
`

const IntlStartlibsProvider = ({children}) => {
  const intl = useIntl()
  const startlibsConfig = useMemo(() => StartlibsConfig(intl),[intl.locale])
  return <StartlibsProvider value={startlibsConfig}>{children}</StartlibsProvider>
}

const INTL_PATHS = ['/','/expert/*','/expert*',
  '/provider/medicalRelease/*','/provider/medicalRelease*',
  '/uploadMedicalRecords/*','/uploadMedicalRecords*',
  '/icons',
  '/patient/*','/patient*',
  '/access/*','/access*',
  '/invalid-login']

const App = () => {
  // var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var ua = navigator.userAgent;
  var isSafari165 = false
  var isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  var safariVersion;

  if (isSafari) {
    var safariVersionMatch = ua.match(/Version\/(\d+\.\d+)/);
    if (safariVersionMatch && safariVersionMatch[1]) {
      safariVersion = parseFloat(safariVersionMatch[1]);
      if(safariVersion >= 16.5 && safariVersion < 17.6){
        isSafari165 = true
      }
    }
  }
  // const locale = new URLSearchParams(window.location.search).get("locale") || 'en-US' // en-US-LEGAL
  const [[previewCase,previewReady]] = usePreviewCase()
  const isPdfServer = import.meta.env.MODE === 'printer'

  // This has the default colors from expertview - Blue colors.
  // This will be passed to the theme when printing pdf - to prevent errors.
  const customColors = {
    main: "#008bd2",
    secondary: "#1F70A0",
    timeline: "#ddecf4",
    timelineCheck: "#008bd2", 
    enhancedContrastColor: "#0B67A2"
  }

  return <Router><WithLazyResource fallback={null} value={lazyProviderInfo}>{providerInfo =>
  <ThemeProvider theme={createCustomColorTheme(previewCase ? customColors : providerInfo.customColors)}>
    <Routes>
      {INTL_PATHS.map(path => <Route key={path} path={path} element={<I18NInitEnable/>}/>)}
    </Routes>
    <I18NProvider
      defaultLocale={previewCase ? previewCase.info.locale || "en-US" : getInitLocale}
      withUrlParam={shouldAddLocaleUrlParam}
    >
    <IntlStartlibsProvider>
      <>
        <DefaultStyle />
        <TableSlateStyle />
        <ImageSlateStyle />
        {isSafari && isSafari165 && <CustomSafariStyle />}
        <CheckScrollOnBottom/>
        <ProviderTitle/>
        <ProviderErrorBoundary>
          <PageLoadingSuspense>
            {
              previewCase
                ? <PreviewForReport {...previewCase} previewReady={previewReady} isPdfPrinter/>
                : <AppRoutes isPdfServer={isPdfServer}/>
            }
          </PageLoadingSuspense>
        </ProviderErrorBoundary>
        <Notifications/>
        <StartlibsNotifications/>
        <React.Suspense fallback={null}><SetFavicon/></React.Suspense>
        <Routes component={Identity}>
          <Route path="/mobile-app/*" element={<Identity/>}/>
          <Route path="/cms-experts/*" element={<Identity />}/>
          <Route path="*" element={<HelpButton className="JS-fix-dialog-scroll"/>}/>
        </Routes>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1000}}>
          <Slot name="Popup"/>
        </div>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, zIndex: 200}}>
          <Slot name="Portal"/>
          <Slot name="Dialog"/>
          <Slot name="Confirm-Dialog"/>
          <Slot name="Notification"/>
          <Slot name="Notifications"/>
        </div>
      </>
    </IntlStartlibsProvider>
    </I18NProvider>
  </ThemeProvider>}
</WithLazyResource>
  </Router>
}

const SetFavicon = () => {

  const {favicon} = lazyProviderInfo.read()

  useFavicon(favicon)
  return null
}

class EnsureLoggedIn extends React.Component {
  state = {}

  componentDidCatch(error) {
    if (error.invalidateCache) {
      callIfFunction(error.invalidateCache)
      this.setState({navigate: true})
    }
  }

  static getDerivedStateFromError(_error) {
    return {hasError: true}
  }

  render() {
    return null
    // return !this.state.hasError
    //        ? <LoggedIn {...this.props}/>
    //        : this.state.navigate
    //          ? <Redirect to="/access"/>
    //          : null
  }
}

export default App
